import { createContext } from "react"

/**
 * @typedef {Object} NotificationContextValue
 * @property {boolean} isOpen
 * @property {number} count
 * @property {Array} notifications
 * @property {Function} open
 * @property {Function} close
 * @property {Function} toggle
 * @property {Function} addNotification
 * @property {Function} removeNotification
 */

export const NotificationContext = createContext(/** @type {NotificationContextValue} */ ({}))
